import { render } from "./MLoader.vue?vue&type=template&id=42adecd4"
import script from "./MLoader.vue?vue&type=script&lang=js"
export * from "./MLoader.vue?vue&type=script&lang=js"

import "./MLoader.vue?vue&type=style&index=0&id=42adecd4&lang=scss"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__